<template> </template>

<script>
export default {
	name: "Footergrid",
	methods: {
		gotoHome() {
			this.$router.push("/intro");
		},
	},
};
</script>

<style scoped></style>
